import axios from '@axios'

const PREFIX = '/acessos'

export default {
  redefinirSenha(usuario) {
    return axios.post(`${PREFIX}/redefinicao-senha/`, usuario)
  },
}
